import React from 'react'
import classNames from 'classnames'

const Row = ({
  children,
  gap = 4,
  className
}) => {
  const gaps = {
    1: 'gap-x-1',
    2: 'gap-x-2',
    3: 'gap-x-3',
    4: 'gap-x-4',
    5: 'gap-x-5',
    6: 'gap-x-6'
  }

  const rowClass = classNames('grid grid-cols-12',
    className,
    {
      [gaps[gap]]: gap && gaps[gap]
    })

  return (
    <div className={rowClass}>
      {children}
    </div>
  )
}

export default Row
